export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7031.3cfcd6fe.jpg";